import { BASE_IMPORT_DATA } from "@/Modals/WebDataManagement/Mapping/BaseImport/baseImportData";
import CompetitionGroupCompetitionModal from "@/Modals/WebDataManagement/Mapping/CompetitionGroupCompetition/Modal";
import MappingBaseTable from "../BaseTable";
import React from "react";
import { columns } from "./Columns";
import { competitionGroupCompetitionsMappingsApi } from "@/apis/apis";

export default function CompetitionGroupCompetitionPage() {
  return (
    <MappingBaseTable
      label="Competition Group - Competition"
      apiURL={competitionGroupCompetitionsMappingsApi}
      columns={columns()}
      ModalComponent={CompetitionGroupCompetitionModal}
      importData={BASE_IMPORT_DATA.COMPETITION_GROUP_COMPETITION}
      enableAdd={false}
      enableEdit={true}
      enableDelete={false}
    />
  );
}
